import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { contactsDenoDto } from 'src/app/models/contactsDenoDto';
import { contactsDto } from 'src/app/models/contactsDto';
import { createContacts } from 'src/app/models/createContact';
import { denonciation } from 'src/app/models/denonciation';
import { environment } from 'src/environments/environment';
//import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  PATH_GET_CONTACTS = "/crm/contacts/getContacts/";
  PATH_CREATE_CONTACT = "/crm/contacts/";
  PATH_CREATE_DENONCIATION = "/crm/denonciation/";
  PATH_GET_CONTACTS_DENONCIATION = "/crm/denonciation/get-denonciation/";
  PATH_GET_CONTACTS_DENONCIATION_ADMIN = "/crm/denonciation/get-all-denonciations";

//   PATH_VILLE_BY_NOM = "/ville/ville-by-name/";
//   PATH_VILLE_BY_DEPARTEMENT = "/ville/ville-by-departement/"
  constructor(private readonly http: HttpClient) { }
  
  getContactsFromCRM = (nom: string): Observable<contactsDto> => {
    const url = environment.host.domaine+this.PATH_GET_CONTACTS+nom;
    // const url = "https://api.resi-realestate.dev.echonet/options/contacts/getContacts?prop="+nom;
  //  https://api.resi-realestate.dev.echonet/options/contacts/getContacts/
    //    const url = "https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8184/contacts/getContacts?prop="+nom;

    return this.http.get<contactsDto>(url);
  }

  getContactsDenoFromCRM = (mail: string): Observable<contactsDenoDto[]> => {
    const url = environment.host.domaine+this.PATH_GET_CONTACTS_DENONCIATION+mail;
    return this.http.get<contactsDenoDto[]>(url);
  }

  getContactsDenoFromCRMAdmin = (): Observable<contactsDenoDto[]> => {
    const url = environment.host.domaine+this.PATH_GET_CONTACTS_DENONCIATION_ADMIN;
    return this.http.get<contactsDenoDto[]>(url,{ params: this.ToHttpParams(null, 1, 100) });
  }

  createContacts(contact: createContacts): Observable<createContacts>{

    const url = environment.host.domaine+this.PATH_CREATE_CONTACT;

    return this.http.post<createContacts>(url, {

      core_civility:contact.core_civility,
      emailaddress1: contact.emailaddress1,
      lastname: contact.lastname,
      firstname: contact.firstname,
      mobilephone: contact.mobilephone

    });
  }

  denonciation(contactDenonciation: denonciation): Observable<any[]>{

    const url = environment.host.domaine+this.PATH_CREATE_DENONCIATION;

    return this.http.post<any[]>(url, contactDenonciation);
  }

  public ToHttpParams(request: any | null | undefined, page: number, size: number): HttpParams {
      
          let httpParams = new HttpParams();
         
          if(request != null && request != undefined){
          Object.keys(request).forEach((key) => {
      
            if (request[key]) {
      
              httpParams = httpParams.append(key, request[key]);
            }
          });
        }
          httpParams = httpParams.append("page", page);
          httpParams = httpParams.append("size", size);
          
          return httpParams;
      
   }
}
